<template>
  <div>

    <h1 class="text-title font-weight-bold mt-2 mb-4">Estimativa de Cargas Difusas</h1>

    <v-row>
      <v-col cols="12">
        <v-tabs
          v-model="tabs"
          color="secondary lighten-1"
          background-color="transparent"
          slider-color="secondary lighten-1"
        >
          <v-tabs-slider color="secondary lighten-1"></v-tabs-slider>
          <v-tab href="#dbo">DBO</v-tab>
          <v-tab href="#nt">NT</v-tab>
          <v-tab href="#pt">PT</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabs" class="transparent" touchless>
          <v-tab-item value="dbo">
            <v-card
              color="mt-3 pa-2 primary darken-1"
              style="border-radius: 6px"
            >
              <v-card-title class="mb-0">
                <chart-header
                  :authorize="authorize"
                  @fullscreenChart="fullscreenChart"
                  @printChart="printChart"
                  @exportChart="exportChart($event)"
                  @exportCSV="exportCSV"
                  @exportXLS="exportXLS"
                >
                  <template v-slot:title> {{ title }} </template>
                </chart-header>
              </v-card-title>
              <v-card-text>
                <h3 class="subtitle-1 white--text">
                  Selecione o tipo do dado:
                </h3>
                <v-tabs
                  class="hidden-sm-and-down secondary--text text--lighten-1"
                  v-model="tab"
                  active-class="secondary lighten-1 primary--text text--darken-1"
                  background-color="primary darken-1"
                  slider-color="secondary lighten-1"
                >
                  <v-tab
                    class="tab-item-title"
                    v-for="(item, index) in items"
                    :key="index"
                    :id="item.id"
                    >{{ item.title }}</v-tab
                  >
                </v-tabs>

                <v-menu bottom left>
                  <template v-slot:activator="{on, attrs}">
                    <v-btn
                      class="hidden-md-and-up tab-item-title transparent"
                      outlined
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ items[tab].title }}
                      <v-icon> mdi-menu-down </v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item
                      v-for="(item, index) in items"
                      :key="index"
                      @click="changeTabItem(index)"
                    >
                      {{ item.title }}
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-tabs-items v-model="tab" class="primary darken-1" touchless>
                  <v-tab-item key="tab-use-land-tota-dbo">
                    <v-card flat color="primary darken-1">
                      <v-card-text class="px-0 text-center">
                        <div v-if="showAnimation" style="height: 300px">
                          <loading-animation
                            @loopComplete="loadAnimationComplete"
                          ></loading-animation>
                        </div>
                        <d-b-ouse-land-total-chart
                          ref="DBOuseLandTotal"
                          v-show="!showAnimation"
                          :cargas="cargas"
                          :sia="sia"
                          @chartRenderComplete="chartRenderComplete($event)"
                        ></d-b-ouse-land-total-chart>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item class="px-0" key="tab-use-land-normalized-dbo">
                    <v-card flat color="primary darken-1">
                      <v-card-text class="px-0 text-center">
                        <div v-if="showAnimation" style="height: 300px">
                          <loading-animation
                            @loopComplete="loadAnimationComplete"
                          ></loading-animation>
                        </div>
                        <d-b-ouse-land-normalized-chart
                          ref="DBOuseLandNormalized"
                          v-show="!showAnimation"
                          :cargas="cargas"
                          :sia="sia"
                          @chartRenderComplete="chartRenderComplete($event)"
                        ></d-b-ouse-land-normalized-chart>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item value="nt">
            <v-card
              color="mt-3 pa-2 primary darken-1"
              style="border-radius: 6px"
            >
              <v-card-title class="mb-0">
                <chart-header
                  :authorize="authorize"
                  @fullscreenChart="fullscreenChart"
                  @printChart="printChart"
                  @exportChart="exportChart($event)"
                  @exportCSV="exportCSV"
                  @exportXLS="exportXLS"
                >
                  <template v-slot:title> {{ title }}</template>
                </chart-header>
              </v-card-title>
              <v-card-text>
                <h3 class="subtitle-1 white--text">
                  Selecione o tipo do dado:
                </h3>
                <v-tabs
                  class="hidden-sm-and-down secondary--text text--lighten-1"
                  v-model="tab"
                  active-class="secondary lighten-1 primary--text text--darken-1"
                  background-color="primary darken-1"
                  slider-color="secondary lighten-1"
                >
                  <v-tab
                    class="tab-item-title"
                    v-for="(item, index) in items"
                    :key="index"
                    :id="item.id"
                    >{{ item.title }}</v-tab
                  >
                </v-tabs>

                <v-menu bottom left>
                  <template v-slot:activator="{on, attrs}">
                    <v-btn
                      class="hidden-md-and-up tab-item-title transparent"
                      outlined
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ items[tab].title }}
                      <v-icon> mdi-menu-down </v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item
                      v-for="(item, index) in items"
                      :key="index"
                      @click="changeTabItem(index)"
                    >
                      {{ item.title }}
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-tabs-items v-model="tab" class="primary darken-1" touchless>
                  <v-tab-item key="tab-use-land-total-nt">
                    <v-card flat color="primary darken-1">
                      <v-card-text class="px-0 text-center">
                        <div v-if="showAnimation" style="height: 300px">
                          <loading-animation
                            @loopComplete="loadAnimationComplete"
                          ></loading-animation>
                        </div>
                        <n-tuse-land-total-chart
                          ref="NTuseLandTotal"
                          v-show="!showAnimation"
                          :cargas="cargas"
                          :sia="sia"
                          @chartRenderComplete="chartRenderComplete($event)"
                        ></n-tuse-land-total-chart>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item class="px-0" key="tab-use-land-normalized-nt">
                    <v-card flat color="primary darken-1">
                      <v-card-text class="px-0 text-center">
                        <div v-if="showAnimation" style="height: 300px">
                          <loading-animation
                            @loopComplete="loadAnimationComplete"
                          ></loading-animation>
                        </div>
                        <n-tuse-land-normalized-chart
                          ref="NTuseLandNormalized"
                          v-show="!showAnimation"
                          :cargas="cargas"
                          :sia="sia"
                          @chartRenderComplete="chartRenderComplete($event)"
                        ></n-tuse-land-normalized-chart>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item value="pt">
            <v-card
              color="mt-3 pa-2 primary darken-1"
              style="border-radius: 6px"
            >
              <v-card-title class="mb-0">
                <chart-header
                  :authorize="authorize"
                  @fullscreenChart="fullscreenChart"
                  @printChart="printChart"
                  @exportChart="exportChart($event)"
                  @exportCSV="exportCSV"
                  @exportXLS="exportXLS"
                >
                  <template v-slot:title> {{ title }} </template>
                </chart-header>
              </v-card-title>
              <v-card-text>
                <h3 class="subtitle-1 white--text">
                  Selecione o tipo do dado:
                </h3>
                <v-tabs
                  class="hidden-sm-and-down secondary--text text--lighten-1"
                  v-model="tab"
                  active-class="secondary lighten-1 primary--text text--darken-1"
                  background-color="primary darken-1"
                  slider-color="secondary lighten-1"
                >
                  <v-tab
                    class="tab-item-title"
                    v-for="(item, index) in items"
                    :key="index"
                    :id="item.id"
                    >{{ item.title }}</v-tab
                  >
                </v-tabs>

                <v-menu bottom left>
                  <template v-slot:activator="{on, attrs}">
                    <v-btn
                      class="hidden-md-and-up tab-item-title transparent"
                      outlined
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ items[tab].title }}
                      <v-icon> mdi-menu-down </v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item
                      v-for="(item, index) in items"
                      :key="index"
                      @click="changeTabItem(index)"
                    >
                      {{ item.title }}
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-tabs-items v-model="tab" class="primary darken-1" touchless>
                  <v-tab-item key="tab-use-land-total-pt">
                    <v-card flat color="primary darken-1">
                      <v-card-text class="px-0 text-center">
                        <div v-if="showAnimation" style="height: 300px">
                          <loading-animation
                            @loopComplete="loadAnimationComplete"
                          ></loading-animation>
                        </div>
                        <p-tuse-land-total-chart
                          ref="PTuseLandTotal"
                          v-show="!showAnimation"
                          :cargas="cargas"
                          :sia="sia"
                          @chartRenderComplete="chartRenderComplete($event)"
                        ></p-tuse-land-total-chart>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item class="px-0" key="tab-use-land-normalized-pt">
                    <v-card flat color="primary darken-1">
                      <v-card-text class="px-0 text-center">
                        <div v-if="showAnimation" style="height: 300px">
                          <loading-animation
                            @loopComplete="loadAnimationComplete"
                          ></loading-animation>
                        </div>
                        <p-tuse-land-normalized-chart
                          ref="PTuseLandNormalized"
                          v-show="!showAnimation"
                          :cargas="cargas"
                          :sia="sia"
                          @chartRenderComplete="chartRenderComplete($event)"
                        ></p-tuse-land-normalized-chart>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Highcharts from 'highcharts';
import {
  permanenceChartAuthorization,
  rainAndFlowChartAuthorization,
} from '@/helpers/chart_export_authorization';
import Exporting from 'highcharts/modules/export-data';
import ChartHeader from '@/components/common/ChartHeader';
import LoadingAnimation from '@/components/common/LoadingAnimation';
import DBOuseLandTotalChart from '@/components/indicators/IndicatorsLoadEstimationCharts/DBOuseLandTotalChart';
import DBOuseLandNormalizedChart from '@/components/indicators/IndicatorsLoadEstimationCharts/DBOuseLandNormalizedChart';
import NTuseLandTotalChart from '@/components/indicators/IndicatorsLoadEstimationCharts/NTuseLandTotalChart';
import NTuseLandNormalizedChart from '@/components/indicators/IndicatorsLoadEstimationCharts/NTuseLandNormalizedChart';
import PTuseLandTotalChart from '@/components/indicators/IndicatorsLoadEstimationCharts/PTuseLandTotalChart';
import PTuseLandNormalizedChart from '@/components/indicators/IndicatorsLoadEstimationCharts/PTuseLandNormalizedChart';
Exporting(Highcharts);
export default {
  name: 'IndicatorsLoadEstimation',
  components: {
    PTuseLandNormalizedChart,
    PTuseLandTotalChart,
    NTuseLandNormalizedChart,
    NTuseLandTotalChart,
    DBOuseLandNormalizedChart,
    DBOuseLandTotalChart,
    LoadingAnimation,
    ChartHeader,
  },
  props: {
    location: {
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      showAnimation: false,
      tab: 1,
      tabs: 0,
      chartRendered: undefined,
      items: [
        {
          title: 'Uso do solo total',
          id: 'tab-use-land-total',
        },
        {
          title: 'Uso do solo normalizado (por km²)',
          id: 'tab-use-land-normalized',
        },
      ],
      authorize: [],
      sia: undefined,
    };
  },
  mounted() {
    this.authorize = rainAndFlowChartAuthorization;
  },
  watch: {
    location(value) {
      if (value) {
        this.initialize(value);
      }
    },
    tabs(value) {
      if (value) {
        this.initialize(this.location);
      }
    },
    tab() {
      this.initialize(this.location);
    },
  },
  computed: {
    title() {
      return 'Carga Difusa ' + this.tabs.toUpperCase();
    },
    cargas() {
      return this.$store.getters.cargasUsoDoSolo;
    },
  },
  methods: {
    loadAnimationComplete() {
      this.showAnimation = this.loading;
    },
    loadCharts(tab) {
      setTimeout(() => {
        if (this.tabs === 'dbo') {
          if (tab === 0) {
            if (this.$refs.DBOuseLandTotal) {
              this.$refs.DBOuseLandTotal.chartPreprocessing();
              this.authorize = rainAndFlowChartAuthorization;
            }
          } else if (tab === 1) {
            if (this.$refs.DBOuseLandNormalized) {
              this.$refs.DBOuseLandNormalized.chartPreprocessing();
              this.authorize = permanenceChartAuthorization;
            }
          }
        } else if (this.tabs === 'nt') {
          if (tab === 0) {
            if (this.$refs.NTuseLandTotal) {
              this.$refs.NTuseLandTotal.chartPreprocessing();
              this.authorize = rainAndFlowChartAuthorization;
            }
          } else if (tab === 1) {
            if (this.$refs.NTuseLandNormalized) {
              this.$refs.NTuseLandNormalized.chartPreprocessing();
              this.authorize = permanenceChartAuthorization;
            }
          }
        } else if (this.tabs === 'pt') {
          if (tab === 0) {
            if (this.$refs.PTuseLandTotal) {
              this.$refs.PTuseLandTotal.chartPreprocessing();
              this.authorize = rainAndFlowChartAuthorization;
            }
          } else if (tab === 1) {
            if (this.$refs.PTuseLandNormalized) {
              this.$refs.PTuseLandNormalized.chartPreprocessing();
              this.authorize = permanenceChartAuthorization;
            }
          }
        }
      }, 50);
    },
    chartRenderComplete(chart) {
      this.chartRendered = chart;
    },
    exportChart(typeFile) {
      this.chartRendered.exportChart({type: typeFile});
    },
    exportCSV() {
      this.chartRendered.downloadCSV();
    },
    exportXLS() {
      this.chartRendered.downloadXLS();
    },
    fullscreenChart() {
      const fullscreenControl = new Highcharts.Fullscreen(this.chartRendered);
      fullscreenControl.open();
    },
    printChart() {
      this.chartRendered.print();
    },
    changeTabItem(tabIndex) {
      this.tab = tabIndex;
    },
    async initialize(value) {
      this.showAnimation = true;
      this.loading = true;
      await this.$store.dispatch('loadIndicatorCarga', {sias: []});
      if (this.tabs === 'dbo') {
        if (this.tab === 0) {
          await this.$store.dispatch('loadCargasUsoDoSolo', {
            siaIds: [],
            sias: [],
            cargas: 'dbo_dia',
          });
        } else if (this.tab === 1) {
          await this.$store.dispatch('loadCargasUsoDoSolo', {
            siaIds: [],
            sias: [],
            cargas: 'dbo_diakm2',
          });
        }
      } else if (this.tabs === 'nt') {
        if (this.tab === 0) {
          await this.$store.dispatch('loadCargasUsoDoSolo', {
            siaIds: [],
            sias: [],
            cargas: 'nt_dia',
          });
        } else if (this.tab === 1) {
          await this.$store.dispatch('loadCargasUsoDoSolo', {
            siaIds: [],
            sias: [],
            cargas: 'nt_diakm2',
          });
        }
      } else if (this.tabs === 'pt') {
        if (this.tab === 0) {
          await this.$store.dispatch('loadCargasUsoDoSolo', {
            siaIds: [],
            sias: [],
            cargas: 'pt_dia',
          });
        } else if (this.tab === 1) {
          await this.$store.dispatch('loadCargasUsoDoSolo', {
            siaIds: [],
            sias: [],
            cargas: 'pt_diakm2',
          });
        }
      }
      if (value) {
        await this.$store.dispatch('loadSiaDetails', {
          location_id: value?.locationid,
        });
        this.sia = await this.$store.getters.siaDetails;
      }
      this.loadCharts(this.tab);
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.text-title {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 1.3rem;
  line-height: 33px;
  color: #ffffff;
}
.tab-item-title {
  color: var(--v-secondary-lighten1) !important;
  border: 1px solid var(--v-secondary-lighten1);
  text-transform: none;
}
#tab-use-land-total {
  border-radius: 4px 0px 0px 4px;
}
#tab-use-land-normalized {
  border-radius: 0px 4px 4px 0px;
}
</style>
